import { Button } from "@/components/ui/Button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog"

interface DeleteEmailSupportDialogProps {
  isOpen: boolean
  onClose: () => void
}

export function DeleteEmailSupportDialog({
  isOpen,
  onClose,
}: DeleteEmailSupportDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="tw-max-w-lg">
        <DialogHeader>
          <DialogTitle>Account Deletion Request</DialogTitle>
        </DialogHeader>
        <div className="tw-py-4">
          <p className="tw-text-sm tw-text-gray-600">
            Uh oh. It looks like you've already done quite a bit of work. If you
            are sure you want to delete your account, please email
            support@classkick.com
          </p>
        </div>
        <DialogFooter>
          <Button
            variant="default"
            onClick={onClose}
            size="lg"
            className="tw-min-w-[100px]"
          >
            Got it!
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
